<template>
  <ABM></ABM>
</template>

<script>
import ABM from "@/components/Motivos/ABM";
export default {
  components: {
    ABM,
  },
};
</script>

<style></style>
